import {APP_BASE_HREF} from "@angular/common";

export function isAsturias(): boolean {
  const href = isAPP_BASE_HREF_SSR() ? APP_BASE_HREF.toString() : getWindowHref();
  return href.toLowerCase().includes("asturias") || href.includes("localhost:4500");
}

export function isPortugal(): boolean {
  const href = isAPP_BASE_HREF_SSR() ? APP_BASE_HREF.toString() : getWindowHref();
  return href.toLowerCase().includes("portugal") || href.includes("localhost:4400");
}

export function isValencia(): boolean {
  const href = isAPP_BASE_HREF_SSR() ? APP_BASE_HREF.toString() : getWindowHref();
  return href.toLowerCase().includes("valencia") || href.includes("localhost:4600");
}

function isAPP_BASE_HREF_SSR(): boolean {
  // If APP_BASE_HREF doesn't contain the application URL value, then it's not SSR and we can use window.location.href
  return APP_BASE_HREF.toString().toLowerCase().includes("gonvarri");
}

function getWindowHref(): string {
  // Lazy evaluation of window.location.href, since it was causing an error of window not defined in SSR
  if (typeof window !== 'undefined') {
    return window.location.href;
  }
  return ''; // Fallback for SSR
}